import { TAnalyticsEventSchema } from '@shared/types';

import { sendEventToGarfield } from './GarfieldUtils';

const { onCLS, onFCP, onFID, onINP, onLCP, onTTFB } = require('web-vitals');

export const sendWebVitalAnalytics = (metrics: {
	name: string;
	value: string;
	navigationType: string;
}) => {
	const { name = '', value = '', navigationType } = metrics;

	const eventObj: TAnalyticsEventSchema = {
		eventType: 'custom',
		eventData: {
			name: `web-vitals-${name}`,
			value,
			additionalData: {
				navigation_type: navigationType,
			},
		},
	};

	sendEventToGarfield(eventObj);
};

export const captureWebVitals = () => {
	onCLS(sendWebVitalAnalytics);
	onFID(sendWebVitalAnalytics);
	onLCP(sendWebVitalAnalytics);
	onFCP(sendWebVitalAnalytics);
	onINP(sendWebVitalAnalytics);
	onTTFB(sendWebVitalAnalytics);
};
